// https://github.com/facebook/draft-js/issues/1188
const _addRange = Selection.prototype.addRange;
Selection.prototype.addRange = function() {
  _addRange.apply(this, arguments);

  if (this.rangeCount === 0) {
    _addRange.apply(this, arguments);
  }
};
